<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">
    <span *ngIf="!readOnly && !forwardingEmail">New </span>
    <span *ngIf="forwardingEmail">Forwarding </span>
    Email
    <span *ngIf="isDraftEmail" class="text-danger ms-2">[DRAFT]</span>
  </h5>
  <div class="d-flex align-items-center gap-2 ms-auto">
    <button *ngIf="isDraftEmail" type="button" class="btn btn-outline-danger btn-sm" (click)="dismissDraft()">
      Dismiss <fa-icon [icon]="faTrashAlt"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body p-0">
  <form [formGroup]="emailDetails" autocomplete="off">

    <!-- Action buttons bar -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 justify-content-end">
      <button type="button" class="btn btn-sm"
        [ngClass]="{'btn-danger': isHighImportance, 'btn-outline-secondary': !isHighImportance}"
        (click)="toggleHighImportance()"
        [disabled]="readOnly">
        <fa-icon [icon]="faExclamation"></fa-icon> High Importance
      </button>
      <button *ngIf="readOnly" type="button" class="btn btn-outline-secondary btn-sm" (click)="forwardEmail()">
        <fa-icon [icon]="faLongArrowRight" size="lg"></fa-icon> Forward
      </button>
    </div>

     <!-- To/CC row -->
    <div class="d-flex align-items-start gap-2 px-3 py-2">

      <!-- Send button -->
      <div *ngIf="!readOnly" class="d-flex flex-column align-self-stretch">
        <button type="button" class="btn btn-outline-success h-100"
          [disabled]="sendingEmail || emailDetails.invalid"
          (click)="sendEmail()">
          <fa-icon [icon]="faPaperPlane" size="lg"></fa-icon><br>Send
        </button>
      </div>

      <div *ngIf="readOnly" style="width: 53px; min-width: 53px;"></div>

      <div class="flex-grow-1">
        <!-- To -->
        <div class="d-flex align-items-center gap-2 mb-2">
          <button type="button" class="btn btn-outline-secondary btn-sm"
            style="width: 60px;"
            [disabled]="sendingEmail || readOnly"
            (click)="selectAddress('to')">To</button>
          <input class="form-control form-control-sm" formControlName="toAddresses" (change)="validateEmails()">
        </div>
        <!-- CC -->
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-outline-secondary btn-sm"
            style="width: 60px;"
            [disabled]="sendingEmail || readOnly"
            (click)="selectAddress('cc')">CC</button>
          <input class="form-control form-control-sm" formControlName="ccAddresses">
        </div>
      </div>

    </div>

    <!-- Subject/From row -->
    <div class="d-flex align-items-start gap-2 px-3 py-2 border-bottom">

      <!-- Save draft button -->
      <div *ngIf="!readOnly && !forwardingEmail" class="d-flex flex-column align-self-stretch">
        <button type="button" class="btn btn-outline-secondary h-100" (click)="saveDraftEmail()">
          <fa-icon [icon]="faSave" size="lg"></fa-icon><br>Save
        </button>
      </div>
       <div *ngIf="readOnly || forwardingEmail" style="width: 53px; min-width: 53px;"></div>

      <div class="flex-grow-1">
        <!-- Subject -->
        <div class="d-flex align-items-center gap-2 mb-2">
          <label class="form-label mb-0 fw-semibold text-end" style="width: 60px;">Subject</label>
          <input class="form-control form-control-sm" formControlName="subject">
        </div>
        <!-- From -->
        <div class="d-flex align-items-center gap-2">
          <label class="form-label mb-0 fw-semibold  text-end" style="width: 60px;">From</label>
          <select *ngIf="!readOnly" class="form-select form-select-sm" formControlName="fromUserTypeId">
            <option [value]="0">enquiries@adlingtonlaw.co.uk</option>
            <option [value]="1">{{currentUserEmail}}</option>
          </select>
          <span *ngIf="readOnly" class="small text-muted">{{fromEmailAddress}}</span>
        </div>
      </div>

    </div>

    <!-- Attachments row -->
    <div *ngIf="caseFiles.length > 0" class="d-flex align-items-center gap-2 px-3 py-2 border-bottom">
      <fa-icon [icon]="faPaperclip" size="lg"></fa-icon>
      <div class="d-flex flex-wrap gap-2">
        <span *ngFor="let file of caseFiles" class="d-flex align-items-center gap-1 badge bg-light text-dark border">
          <span class="text-success" style="cursor: pointer;" (click)="openFile(file)">{{file.fileName}}</span>
          <button *ngIf="!readOnly" type="button" class="btn-close btn-close-sm ms-1"
            style="font-size: 0.6rem;"
            (click)="removeAttachment(file.caseFileId)">
          </button>
        </span>
      </div>
    </div>

    <!-- CKEditor / read-only body -->
    <div class="px-3 py-2 border-bottom">
      <div *ngIf="!readOnly">
        <ckeditor formControlName="body"
                  [editor]="Editor"
                  [data]="data"
                  [config]="config"
                  (ready)="onCkEditorReady($event)"></ckeditor>
      </div>

      <div *ngIf="readOnly || forwardingEmail" class="border rounded p-2">
        <div [innerHTML]="emailBody | emailBodyHtmlPipe"></div>
      </div>
    </div>


    <!-- Email signature -->
    <div *ngIf="!readOnly" class="px-3 py-2 border-bottom text-muted small">
      <div [innerHTML]="emailSignatureHtml"></div>
    </div>

  </form>



</div>

<!-- Footer -->
<div class="modal-footer" *ngIf="readOnly">
  <div class="small text-muted">
    <div>Date Created: {{emailObj.queuedDate | date:'dd/MM/yyyy HH:mm'}}</div>
    <div>Date Sent: {{emailObj.sentDate | date:'dd/MM/yyyy HH:mm'}}</div>
  </div>
</div>
